import React from "react";
import Hero from "./Components/Title/animate";
import About from "./Components/About/about";
import Projects from "./Components/Projects/projects";
import Gallery from "./Components/Gallery/gallery";
import Contact from "./Components/Contact/contact";
import "./styles.scss";

// Native scrolling throughout. Each section owns its own ScrollTriggers.
const Home = () => (
  <div className="home">
    <Hero />
    <About />
    <Projects />
    <Gallery />
    <Contact />
  </div>
);

export default Home;
